export default "__VITE_ASSET__ubHI_ZTm__"